var t=function(t){var n=typeof t;return null!=t&&("object"==n||"function"==n)};export{t as default};
//# sourceMappingURL=isObject.js.map
